import { render } from "./VsListHeader.vue?vue&type=template&id=903a54ee"
import script from "./VsListHeader.vue?vue&type=script&lang=js"
export * from "./VsListHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__